export const API_URL = 'https://www.powerlego.com/ApiGateway/';
export const SIDEBYSIDE_API_URL = 'https://bb0xg7o51l.execute-api.us-east-2.amazonaws.com/beta';
export const ACC_KEY = '373da3d2fa704803b1e6c2ea1527cacc';